import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useUrlFiltersCore } from '@codametrix/client-url-state';
import type {
  NavigateOptions,
  UrlLocation,
  UseUrlFiltersCoreOptions,
  UseUrlFiltersCoreResult
} from '@codametrix/client-url-state';

export type UseUrlFiltersOptions = Omit<
  UseUrlFiltersCoreOptions,
  'location' | 'navigate'
>;

/**
 * Binds the router-agnostic `useUrlFiltersCore` to this app's react-router-dom v5 router. Written
 * once per app: a view supplies `specs`, `basePath` and `apply`.
 */
export const useUrlFilters = (
  options: UseUrlFiltersOptions
): UseUrlFiltersCoreResult => {
  const location = useLocation();
  const history = useHistory();

  const navigate = useCallback(
    (to: UrlLocation, navigateOptions?: NavigateOptions) => {
      if (navigateOptions?.replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    },
    [history]
  );

  return useUrlFiltersCore({
    ...options,
    location: { pathname: location.pathname, search: location.search, action: history.action },
    navigate
  });
};
